import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import cargoOfficerAddRequestFactory from "./add/cargo-officer-add-request.factory";
import CargoOfficerAddRequest, {
  CargoOfficerAddRequestBody,
} from "./add/cargo-officer-add.request";

const cargoOfficerApiService = () => {
  const add = (
    request: CargoOfficerAddRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/cargo-officers`;

    const body: CargoOfficerAddRequestBody =
      cargoOfficerAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return {
    add,
  };
};

export default cargoOfficerApiService;
